import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
  typography: () => ({
    fontSize: 16,
  }),
});

export default theme;
